import { connect } from 'react-redux'
import { sagaActions } from 'store/sagas'
import Notifications from './Notifications'
import { currentUserSettingsSelector } from 'selectors/currentUserSettings'

export default connect(
  (state, props) => {
    return {
      settings: currentUserSettingsSelector(state, props)
    }
  },
  {
    requestChangeUserSettings: sagaActions.requestChangeUserSettings
  }
)(Notifications)
